/* eslint-disable */
// this is autogenerated code (we do not care about the linter)

import * as Types from "./types.graphql-gen";

import { gql } from "apollo-angular";
import { Injectable } from "@angular/core";
import * as Apollo from "apollo-angular";
export type VisionTradingFeeBenefitFetchQueryVariables = Types.Exact<{
	fiatId: Types.Scalars["ID"];
}>;

export type VisionTradingFeeBenefitFetchQuery = {
	__typename?: "Query";
	visionTradingFeeBenefit: {
		__typename?: "VisionTradingFeeBenefitResponse";
		amount: { __typename?: "CurrencyAmount"; value: string };
	};
};

export const VisionTradingFeeBenefitFetchDocument = gql`
	query visionTradingFeeBenefitFetch($fiatId: ID!) {
		visionTradingFeeBenefit(fiatId: $fiatId) {
			amount {
				value
			}
		}
	}
`;

@Injectable({
	providedIn: "root"
})
export class VisionTradingFeeBenefitFetchGQLService extends Apollo.Query<
	VisionTradingFeeBenefitFetchQuery,
	VisionTradingFeeBenefitFetchQueryVariables
> {
	document = VisionTradingFeeBenefitFetchDocument;

	constructor(apollo: Apollo.Apollo) {
		super(apollo);
	}
}
